export const CardUsagGray = () => {
    return (
        <svg width="114" height="114" viewBox="0 0 114 114" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.42">
                <path d="M29.677 29.6218C28.8479 29.239 27.8639 29.5983 27.4764 30.4273L26.1847 33.194L37.4155 33.1939L29.677 29.6218Z" fill="#9DAAAE" />
            </g>
            <g opacity="0.42">
                <path d="M16.955 52.9737L11.0365 65.656C10.8486 66.0553 10.8298 66.5156 10.9825 66.9265C11.067 67.1566 11.1985 67.3634 11.3676 67.5325C11.5062 67.6711 11.6658 67.7838 11.8467 67.866L16.9548 70.2217L16.955 52.9737Z" fill="#9DAAAE" />
            </g>
            <g opacity="0.42">
                <path opacity="0.42" d="M75.1085 95.2458L81.8794 80.734L63.3023 80.734L69.6012 83.6415C70.435 84.0149 70.8012 85.0106 70.4137 85.8444C70.0309 86.6782 69.0422 87.0422 68.2107 86.657L60.2068 82.9651C60.0236 82.8805 59.864 82.7678 59.7277 82.6315C59.2509 82.1547 59.0936 81.4102 59.3942 80.7621C59.3989 80.7527 59.4083 80.748 59.413 80.7386L39.7273 80.7386L72.9079 96.0513C73.7392 96.4365 74.7233 96.0771 75.1085 95.2458Z" fill="#9DAAAE" />
            </g>
            <path opacity="0.42" d="M94.056 75.7524L94.056 38.1751C94.056 37.2592 93.3114 36.5146 92.3955 36.5146L21.9382 36.5147C21.0223 36.5147 20.2778 37.2592 20.2778 38.1751L20.2778 75.7524C20.2753 76.2104 20.4609 76.6261 20.7616 76.9267C21.0622 77.2274 21.4778 77.4129 21.9359 77.4152L92.3932 77.4152C93.3114 77.4129 94.0537 76.6707 94.056 75.7524Z" fill="#9DAAAE" />
        </svg>


    );
};
